
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/myAccount/send-otp-challenge",
      function () {
        return require("private-next-pages/loyalty/myAccount/send-otp-challenge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/myAccount/send-otp-challenge"])
      });
    }
  